export interface PromptMetadata {
  created_at: string;
  updated_at: string;
  created_by: string;
}

export interface Prompt {
  _id?: string;
  prompt_id: string;
  name: string;
  description: string;
  topic_id: string;
  query_keywords: string[];
  query_embeddings?: number[];
  prompt_template: string;
  required_tools: string[];
  status: PromptStatus;
  metadata: PromptMetadata;
}

export interface CreatePromptDto {
  prompt_id: string;
  name: string;
  description: string;
  topic_id: string;
  query_keywords: string[];
  prompt_template: string;
  required_tools: string[];
  status: PromptStatus;
}

export interface UpdatePromptDto {
  name?: string;
  description?: string;
  topic_id?: string;
  query_keywords?: string[];
  prompt_template?: string;
  required_tools?: string[];
  status?: PromptStatus;
}

export interface PromptListResponse {
  prompts: Prompt[];
  total: number;
  page: number;
  limit: number;
}

export interface PromptResponse {
  prompt: Prompt;
}

export interface PromptVersionHistoryItem {
  _id?: string;
  version_number: number;
  updated_at: string;
  updated_by: string;
  operation_type: 'create' | 'update' | 'delete';
  document_state: Prompt;
}

export interface PromptVersionHistoryResponse {
  prompt_id: string;
  versions: PromptVersionHistoryItem[];
  total: number;
}

export enum PromptStatusEnum {
  ACTIVE = 'active',
  DRAFT = 'draft',
  ARCHIVED = 'archived',
}

export type PromptStatus =
  | PromptStatusEnum.ACTIVE
  | PromptStatusEnum.DRAFT
  | PromptStatusEnum.ARCHIVED;

// Prompt Topic types
export interface PromptTopicMetadata {
  created_at: string;
  updated_at: string;
  created_by: string;
}

export interface PromptTopic {
  _id?: string;
  topic_id: string;
  name: string;
  description: string;
  metadata: PromptTopicMetadata;
}

export interface CreatePromptTopicDto {
  name: string;
  description: string;
}

export interface UpdatePromptTopicDto {
  name?: string;
  description?: string;
}

export interface PromptTopicListResponse {
  topics: PromptTopic[];
  total: number;
}

export interface PromptTopicResponse {
  topic: PromptTopic;
}
